export default __webpack_public_path__ + "static/media/home.e7161afd.svg";